import { UserService } from '@/services/UserService';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Settings.scss';

type ErrorState = {
  [key: string]: string;
};

const initialPasswordState = {
  // current_password: '',
  new_password: '',
  confirm_password: '',
};
const initialIPINState = {
  oldIPIN: '',
  newIPIN: '',
  retypeIPIN: '',
};
const initialErrorState = {
  // current_password: '',
  new_password: '',
  confirm_password: '',
  oldIPIN: '',
  newIPIN: '',
  retypeIPIN: '',
};

function Settings() {
  const [activeTab, setActiveTab] = useState(0);
  const [passwordForm, setPasswordForm] = useState({ ...initialPasswordState });
  const [ipinForm, setIPINForm] = useState({ ...initialIPINState });
  const [error, setError] = useState<ErrorState>({ ...initialErrorState });
  const [submitted, setSubmitted] = useState(false);

  const validatePassword = () => {
    const temp: ErrorState = {};
    let isValid = true;

    // if (!passwordForm.current_password) {
    //   temp.current_password = 'Old password is required';
    //   isValid = false;
    // } else if (passwordForm.current_password.length < 6) {
    //   temp.current_password = 'Password must be at least 6 digits';
    //   isValid = false;
    // }

    if (!passwordForm.new_password) {
      temp.new_password = 'New password is required';
      isValid = false;
    } else if (passwordForm.new_password.length < 6) {
      temp.new_password = 'Password must be at least 6 digits';
      isValid = false;
    }

    if (!passwordForm.confirm_password) {
      temp.confirm_password = 'Re-type password is required';
      isValid = false;
    } else if (passwordForm.confirm_password !== passwordForm.new_password) {
      temp.confirm_password = 'Passwords do not match';
      isValid = false;
    }

    setError(temp);
    return isValid;
  };

  const validateIPIN = () => {
    const temp: ErrorState = {};
    let isValid = true;

    if (!ipinForm.oldIPIN) {
      temp.oldIPIN = 'Old IPIN is required';
      isValid = false;
    } else if (ipinForm.oldIPIN.length < 6) {
      temp.oldIPIN = 'IPIN must be at least 6 digits';
      isValid = false;
    }

    if (!ipinForm.newIPIN) {
      temp.newIPIN = 'New IPIN is required';
      isValid = false;
    } else if (ipinForm.newIPIN.length < 6) {
      temp.newIPIN = 'IPIN must be at least 6 digits';
      isValid = false;
    }

    if (!ipinForm.retypeIPIN) {
      temp.retypeIPIN = 'Re-type IPIN is required';
      isValid = false;
    } else if (ipinForm.retypeIPIN !== ipinForm.newIPIN) {
      temp.retypeIPIN = 'IPINs do not match';
      isValid = false;
    }

    setError(temp);
    return isValid;
  };

  useEffect(() => {
    validateIPIN();
    validatePassword();
  }, [ipinForm, passwordForm]);

  const handleTabChange = (index: number) => {
    setActiveTab(index);
    setPasswordForm(initialPasswordState);
    setIPINForm(initialIPINState);
    setError(initialErrorState);
    setSubmitted(false);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPasswordForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value.trim(),
    }));
  };
  const handleIPINChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIPINForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value.trim(),
    }));
  };

  const handleUpdatePassword = (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    setSubmitted(true);
    if (!validatePassword()) return;

    try {
      UserService.updatePassword(passwordForm).then((res) => {
        toast.success('Password updated successfully');
        setPasswordForm(initialPasswordState);
        setError(initialErrorState);
        setSubmitted(false);
      });
    } catch (error) {
      toast.error('Something went wrong');
    }
  };

  const tabData = [
    {
      label: 'Update Password',
      content: (
        <form
          className="tab-setting-ui"
          onSubmit={handleUpdatePassword}
          autoComplete="off"
        >
          <div className="grid grid--2 grid--sm-mob--1">
            {/* <div className="form-group span-full">
              <label htmlFor="old-password">Old Password</label>
              <input
                type="password"
                id="old-password"
                name="current_password"
                value={passwordForm.current_password}
                onChange={handlePasswordChange}
                autoComplete="off"
                className={submitted && error.current_password ? 'error' : ''}
              />
              {submitted && error.current_password && (
                <span className="error-message">{error.current_password}</span>
              )}
            </div> */}
            <div className="form-group">
              <label htmlFor="new-password">New Password</label>
              <input
                type="password"
                id="new-password"
                name="new_password"
                value={passwordForm.new_password}
                onChange={handlePasswordChange}
                autoComplete="off"
                className={submitted && error.new_password ? 'error' : ''}
              />
              {submitted && error.new_password && (
                <span className="error-message">{error.new_password}</span>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="re-type-password">Re-type New Password</label>
              <input
                type="password"
                id="re-type-password"
                name="confirm_password"
                value={passwordForm.confirm_password}
                onChange={handlePasswordChange}
                autoComplete="off"
                className={submitted && error.confirm_password ? 'error' : ''}
              />
              {submitted && error.confirm_password && (
                <span className="error-message">{error.confirm_password}</span>
              )}
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn--pri">
              Save
            </button>
          </div>
        </form>
      ),
    },
    // {
    //   label: 'Reset IPIN',
    //   content: (
    //     <form
    //       className="tab-setting-ui"
    //       onSubmit={handleResetIPIN}
    //       autoComplete="off"
    //     >
    //       <div className="grid grid--2 grid--sm-mob--1">
    //         <div className="form-group span-full">
    //           <label htmlFor="old-ipin">Enter IPIN</label>
    //           <input
    //             type="password"
    //             id="old-ipin"
    //             name="oldIPIN"
    //             value={ipinForm.oldIPIN}
    //             onChange={handleIPINChange}
    //             autoComplete="off"
    //             className={submitted && error.oldIPIN ? 'error' : ''}
    //           />
    //           {submitted && error.oldIPIN && (
    //             <span className="error-message">{error.oldIPIN}</span>
    //           )}
    //         </div>
    //         <div className="form-group">
    //           <label htmlFor="new-ipin">New IPIN</label>
    //           <input
    //             type="password"
    //             id="new-ipin"
    //             name="newIPIN"
    //             value={ipinForm.newIPIN}
    //             onChange={handleIPINChange}
    //             autoComplete="off"
    //             className={submitted && error.newIPIN ? 'error' : ''}
    //           />
    //           {submitted && error.newIPIN && (
    //             <span className="error-message">{error.newIPIN}</span>
    //           )}
    //         </div>
    //         <div className="form-group">
    //           <label htmlFor="re-type-ipin">Re-type New IPIN</label>
    //           <input
    //             type="password"
    //             id="re-type-ipin"
    //             name="retypeIPIN"
    //             value={ipinForm.retypeIPIN}
    //             onChange={handleIPINChange}
    //             autoComplete="off"
    //             className={submitted && error.retypeIPIN ? 'error' : ''}
    //           />
    //           {submitted && error.retypeIPIN && (
    //             <span className="error-message">{error.retypeIPIN}</span>
    //           )}
    //         </div>
    //       </div>
    //       <div className="form-actions">
    //         <button type="submit" className="btn btn--pri">
    //           Save
    //         </button>
    //       </div>
    //     </form>
    //   ),
    // },
  ];

  return (
    <div className="profile-main">
      <div className="profile-content">
        <div className="head-profile">
          <h1 className="page-title">Change Password</h1>
          <Link className='btn-text' to={`/profile/my-account`}>
            <i className='cs-icon icon-arrow-left'></i>Back to Profile
          </Link>
        </div>

        {/* <div className="tabbing-profile">
          <ul>
            {tabData.map((tab, index) => (
              <li
                key={index}
                className={index === activeTab ? 'active' : ''}
                onClick={() => handleTabChange(index)}
              >
                {tab.label}
              </li>
            ))}
          </ul>
        </div> */}
        <div className="tabbing-content">{tabData[activeTab].content}</div>
      </div>
    </div>
  );
}

export default Settings;
